/* eslint-disable indent */

interface EnvironmentConfig {
    apiBaseUrl: string;
    clerkApiKey?: string;
    googleApiKey?: string;
}

export const isPodEnabledEnvironment = (): boolean => {
    switch (window.location.hostname) {
        case 'localhost':
        case 'ofstest1.orderly.io':
        case 'ofstest2.orderly.io':
        case 'ofstest3.orderly.io':
        case 'ofstest4.orderly.io':
        case 'ofstest5.orderly.io':
        case 'app-apac.orderly.io':
        case 'app.orderly.io':
        case 'app-uat.orderly.io':
        case 'app-apac-uat.orderly.io':
            return true;
        default:
            return false;
    }
};

export const isReturnToVendorButtonVisibleForFranchise = (franchiseName: string): boolean => {
    switch (franchiseName) {
        case 'NE Apple Green GB':
        case 'Chick-fil-A Singapore':
        case 'Chick-fil-A UK':
        case 'Pasta Evangelists UK':
        case 'Insomnia Cookies UK':
        case 'BK':
            return false;
        default:
            return true;
    }
};

const sharedTestConfig: EnvironmentConfig = {
    apiBaseUrl: '/api',
    clerkApiKey: 'pk_test_Z2VudGxlLWJ1enphcmQtOTYuY2xlcmsuYWNjb3VudHMuZGV2JA',
    googleApiKey: 'AIzaSyAn3FgyVwPfbulsKlqDwOWTpwg2ChYe-yk',
};

const orderlySaasUat: EnvironmentConfig = {
    apiBaseUrl: '/api',
    clerkApiKey: 'pk_test_cGF0aWVudC1yYXZlbi04LmNsZXJrLmFjY291bnRzLmRldiQ',
    googleApiKey: 'AIzaSyAn3FgyVwPfbulsKlqDwOWTpwg2ChYe-yk',
};

const orderlySaaSProdEnvironment: EnvironmentConfig = {
    apiBaseUrl: '/api',
    clerkApiKey: 'pk_live_Y2xlcmsub3JkZXJseS5pbyQ',
    googleApiKey: 'AIzaSyCxoP60g2WUZ4SMXsgHj9ptQXfj1d30i0M',
};

const environmentMapping: { [hostname: string]: EnvironmentConfig } = {
    //Dev
    'localhost': sharedTestConfig,
    //QA
    'ofstest1.orderly.io': sharedTestConfig,
    'ofstest2.orderly.io': sharedTestConfig,
    'ofstest3.orderly.io': sharedTestConfig,
    'ofstest4.orderly.io': sharedTestConfig,
    'ofstest5.orderly.io': sharedTestConfig,
    //UAT SaaS
    'app-uat.orderly.io': orderlySaasUat,
    'orderly-sscm-uat-lac.orderly.io': orderlySaasUat,
    'sscm-apac-uat.orderly.io': orderlySaasUat,
    'app-apac-uat.orderly.io': orderlySaasUat,
    //Prod SaaS
    'app.orderly.io': orderlySaaSProdEnvironment,
    'app-apac.orderly.io': orderlySaaSProdEnvironment,    
};

export const getApiConfig = (): EnvironmentConfig => {
    const hostname = window.location.hostname;
    return environmentMapping[hostname] ?? sharedTestConfig;
};
